import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ReportingContainerBaseConfig } from '../../../base';
import { DocumentNewController, DocumentNewLoader } from './documentNewInterface';
import { DocumentNewContainerProps, DocumentNewViewProps } from './documentNewProps';

export function createDocumentNewContainer(
    config: ReportingContainerBaseConfig,
    loader: DocumentNewLoader,
    controller: DocumentNewController,
    View: React.FC<DocumentNewViewProps>
): React.FC<DocumentNewContainerProps> {
    const {
        context: { useContext },
    } = config;

    return config.state.editor.subscribe(({ ...containerProps }) => {
        const context = useContext();
        const navigate = useNavigate();

        const data = loader.useLoad(context, {});

        const props = controller.useProps(context, data, {
            onCreate() {
                // Navigate to the report generation page
                navigate('/reporting/home');
            },
        });

        return <View {...props} />;
    });
}
